// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1TPIi","mainLogo":"Header_mainLogo__198_K","links":"Header_links__2c-lL"};